var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHomeInstruction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 109,
    viewBox: "0 0 105 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9_29745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3292 25.7224C67.1675 25.7224 79.2142 37.7692 79.2142 52.6075V53.4795C79.2142 68.3178 67.1675 80.3646 52.3292 80.3646C37.4909 80.3646 25.4441 68.3178 25.4441 53.4795V52.6075C25.4441 37.7692 37.4909 25.7224 52.3292 25.7224Z",
    fill: "var(--primary-button-color)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4995 12C72.0933 12 88 27.9067 88 47.4995V48.651C88 68.2437 72.0933 84.1505 52.5005 84.1505C32.9067 84.1515 17 68.2437 17 48.651V47.4995C17 27.9067 32.9067 12 52.4995 12Z",
    fill: "var(--primary-button-color)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_29745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6246 63H38.635C35.5281 63 33 60.4719 33 57.365V38.635C33 35.5281 35.5281 33 38.635 33H66.6246C69.7316 33 72.2596 35.5281 72.2596 38.635V57.365C72.2596 60.4719 69.7316 63 66.6246 63ZM38.635 34.0912C36.1295 34.0912 34.0912 36.1304 34.0912 38.635V57.365C34.0912 59.8705 36.1304 61.9088 38.635 61.9088H66.6246C69.1302 61.9088 71.1685 59.8696 71.1685 57.365V38.635C71.1685 36.1295 69.1293 34.0912 66.6246 34.0912H38.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5227 40.0638H33.5456C33.244 40.0638 33 39.8198 33 39.5182C33 39.2166 33.244 38.9727 33.5456 38.9727H65.5227C65.8243 38.9727 66.0682 39.2166 66.0682 39.5182C66.0682 39.8198 65.8243 40.0638 65.5227 40.0638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3902 36.7009C39.4759 36.1728 39.1173 35.6752 38.5892 35.5895C38.0611 35.5037 37.5634 35.8624 37.4777 36.3905C37.392 36.9186 37.7506 37.4162 38.2787 37.5019C38.8068 37.5876 39.3044 37.229 39.3902 36.7009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7717 36.7014C42.8575 36.1733 42.4988 35.6757 41.9707 35.59C41.4426 35.5042 40.945 35.8629 40.8593 36.391C40.7736 36.9191 41.1322 37.4167 41.6603 37.5024C42.1884 37.5881 42.686 37.2295 42.7717 36.7014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1389 36.7683C46.2618 36.2476 45.9393 35.7259 45.4186 35.603C44.8979 35.4801 44.3762 35.8026 44.2533 36.3233C44.1304 36.844 44.4529 37.3657 44.9736 37.4886C45.4943 37.6115 46.016 37.289 46.1389 36.7683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3853 50.7957H38.9208C38.6192 50.7957 38.3752 50.5517 38.3752 50.2501V43.2826C38.3752 42.981 38.6192 42.7371 38.9208 42.7371H50.3853C50.6869 42.7371 50.9309 42.981 50.9309 43.2826V50.2501C50.9309 50.5517 50.6869 50.7957 50.3853 50.7957ZM39.4664 49.7045H49.8397V43.8282H39.4664V49.7045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3389 50.7957H54.8744C54.5728 50.7957 54.3289 50.5517 54.3289 50.2501V43.2826C54.3289 42.981 54.5728 42.7371 54.8744 42.7371H66.3389C66.6405 42.7371 66.8845 42.981 66.8845 43.2826V50.2501C66.8845 50.5517 66.6405 50.7957 66.3389 50.7957ZM55.42 49.7045H65.7934V43.8282H55.42V49.7045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3855 54.639H46.5492C46.2476 54.639 46.0037 54.395 46.0037 54.0934C46.0037 53.7918 46.2476 53.5479 46.5492 53.5479H50.3855C50.6871 53.5479 50.931 53.7918 50.931 54.0934C50.931 54.395 50.6871 54.639 50.3855 54.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6283 54.639H38.9208C38.6192 54.639 38.3752 54.395 38.3752 54.0934C38.3752 53.7918 38.6192 53.5479 38.9208 53.5479H42.6283C42.9299 53.5479 43.1739 53.7918 43.1739 54.0934C43.1739 54.395 42.9299 54.639 42.6283 54.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3853 58.4369H38.9208C38.6192 58.4369 38.3752 58.1929 38.3752 57.8913C38.3752 57.5897 38.6192 57.3457 38.9208 57.3457H50.3853C50.6869 57.3457 50.9309 57.5897 50.9309 57.8913C50.9309 58.1929 50.6869 58.4369 50.3853 58.4369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3389 54.639H54.8744C54.5728 54.639 54.3289 54.395 54.3289 54.0934C54.3289 53.7918 54.5728 53.5479 54.8744 53.5479H66.3389C66.6405 53.5479 66.8845 53.7918 66.8845 54.0934C66.8845 54.395 66.6405 54.639 66.3389 54.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3394 58.4369H62.423C62.1214 58.4369 61.8774 58.1929 61.8774 57.8913C61.8774 57.5897 62.1214 57.3457 62.423 57.3457H66.3394C66.641 57.3457 66.8849 57.5897 66.8849 57.8913C66.8849 58.1929 66.641 58.4369 66.3394 58.4369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7215 58.4369H54.8744C54.5728 58.4369 54.3289 58.1929 54.3289 57.8913C54.3289 57.5897 54.5728 57.3457 54.8744 57.3457H58.7215C59.0231 57.3457 59.267 57.5897 59.267 57.8913C59.267 58.1929 59.0231 58.4369 58.7215 58.4369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9_29745",
    x: 0.444092,
    y: 0.722412,
    width: 103.77,
    height: 104.642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_9_29745"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_29745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.2596,
    height: 30,
    fill: "white",
    transform: "translate(33 33)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeInstruction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-instruction.2e2536fb.svg";
export { ForwardRef as ReactComponent };